/** Quill’s real empty doc is `<p><br></p>`. Controlled `value=""` fights that and react-quill re-applies HTML on every parent render. */
export const EMPTY_QUILL_HTML = "<p><br></p>";

export function stripEditorHtml(html) {
  return (html || "")
    .replace(/<br\s*\/?>/gi, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/<[^>]*>/g, "")
    .trim();
}

export function normalizeRichTextStorage(html) {
  return stripEditorHtml(html) ? String(html) : EMPTY_QUILL_HTML;
}

export function getEditorTextLength(html) {
  return stripEditorHtml(html).length;
}

/** Plain-text snippet for list previews (strips HTML, collapses whitespace). */
export function previewRichTextPlain(html, maxLength = 140) {
  const plain = stripEditorHtml(html).replace(/\s+/g, " ").trim();
  if (!plain) return "";
  if (plain.length <= maxLength) return plain;
  return `${plain.slice(0, maxLength).trimEnd()}…`;
}
